import { useSelector } from 'react-redux';
import { makeFetchEntityByIdSelector } from '../../../selectors/fetch';
import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useAccountSettings = () => {
  const { loading, response: values = {} } = useSelector(
    makeFetchEntityByIdSelector('settings')
  );

  const { onSubmit, loading: pending } = useFetch(
    'account-settings-save',
    Api.SETTINGS_PASSWORD
  );

  const save = (values, onSuccess) => {
    onSubmit({
      body: values,
      method: 'PUT',
      onSuccess,
    });
  };

  return {
    loading,
    pending,
    values,
    save,
  };
};

export default useAccountSettings;
